var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramCards48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pictogram/Small./Cards48",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("g", {
    id: "pictogramCard48",
    transform: "translate(3.000000, 10.000000)",
    stroke: "#4F4C4D",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,0.75 C1.75735931,0.75 0.75,1.75735931 0.75,3 L0.75,25 C0.75,26.2426407 1.75735931,27.25 3,27.25 L39,27.25 C40.2426407,27.25 41.25,26.2426407 41.25,25 L41.25,3 C41.25,1.75735931 40.2426407,0.75 39,0.75 L3,0.75 Z",
    id: "card",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2755071,0.75 L20.0593082,14 L33.2755071,27.25 L39,27.25 C40.2426407,27.25 41.25,26.2426407 41.25,25 L41.25,3 C41.25,1.75735931 40.2426407,0.75 39,0.75 L33.2755071,0.75 Z",
    id: "focus",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00235932,6.06301949 L5.06067071,9.03094036 L7.99763014,11.9417097 L10.9393398,9 L8.00235932,6.06301949 Z",
    id: "brand",
    fill: "#FFFFFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramCards48);
export default __webpack_public_path__ + "static/media/pictogramCards48.16b49916a1ca977b78fecce449e19c22.svg";
export { ForwardRef as ReactComponent };